/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["user-library{display:block;min-width:0;width:100%;flex:1 1 auto}user-library .nav{display:flex;padding:10px 0;color:#898b8c;background-color:#2a2a35;border-bottom:1px solid rgba(255,255,255,.05)}user-library .nav .nav-item{display:block;flex:1 1 auto;text-align:center;color:inherit;font-size:1.1rem}user-library .nav .nav-item.active{color:#fff}user-library .nav .nav-item .mat-icon{display:block;margin:0 auto 5px;width:28px;height:28px}@media only screen and (max-width:768px){user-library .user-library-page{height:calc(100% - 70px)}}"];
export { styles as styles };
